import { render, staticRenderFns } from "./TelegramButton.vue?vue&type=template&id=dd22537e&scoped=true&"
import script from "./TelegramButton.vue?vue&type=script&lang=js&"
export * from "./TelegramButton.vue?vue&type=script&lang=js&"
import style0 from "./TelegramButton.vue?vue&type=style&index=0&id=dd22537e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd22537e",
  null
  
)

export default component.exports